// extracted by mini-css-extract-plugin
module.exports = {"ProgressTracker":"progress-tracker_ProgressTracker__6I8TS typography_bodyFont__Sn75r","notAllowed":"progress-tracker_notAllowed__0v79P"};